import './App.css';

function App()
{
  /* const navigate = useNavigate();

  setTimeout(() =>
  {
    navigate('https://www.kaptyn.com/products/the-hub', { replace: true });
  }, 10000);
  */

  return (
    <div className="App">
      <header className="App-header">
        <p>
          We've moved! You will be re-directed shortly
        </p>
        <a
          className="App-link"
          href="https://www.kaptyn.com/products/the-hub"
        >
          Visit Kaptyn Business Hub
        </a>
      </header>
    </div>
  );
}

export default App;
